// C2b (R5.7b fix, Claude+Sol adjudicated under owner delegation 2026-08-22) — THE ONE CLIENT-SIDE ANSWER TO
// "may this omission claim render?": yes iff its closed-world `search_scope` is PRESENT and passes the STRICT
// checker the engine and the shape validator use (`checkSearchScope`: well-formed, non-empty enumeration, count
// agreeing). Every renderer of an L1 facet level, a clarification flag, a question row or a "Not shown" claim
// asks this and OMITS the claim otherwise — fail-closed, never "render bare".
import { checkSearchScope } from '../../../workers/src/lib/factLedger';

export function scopeValid(scope: unknown): boolean {
  return scope !== undefined && scope !== null && checkSearchScope(scope).ok;
}
